/*
  SLVR pillowcase page sections: buy buttons, hair slider, survey rings and
  the silver animation. Loaded (deferred) by snippets/slvr-pdp-assets.liquid,
  which every section renders, so this file guards against running twice.
*/
(function () {
  if (window.slvrPdpLoaded) return;
  window.slvrPdpLoaded = true;

  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Buy buttons scroll to the main Add to cart button, or to the top if it isn't on the page.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-slvr-buy]');
    if (!link) return;
    event.preventDefault();
    const behavior = motion.matches ? 'auto' : 'smooth';
    const target = document.querySelector('[id^="MainProduct-"] .product-form__submit');
    if (target && target.getClientRects().length) {
      target.scrollIntoView({ behavior, block: 'center' });
    } else {
      window.scrollTo({ top: 0, behavior });
    }
  });

  // Hair before/after slider. The range input stays disabled until this runs.
  customElements.define('slvr-x-compare', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.slvr-hr__range');
      this.photos = this.querySelector('.slvr-hr__photos');
      if (!this.input || !this.photos) return;
      this.update = () => {
        const value = Math.max(0, Math.min(100, Number(this.input.value)));
        this.photos.style.setProperty('--split', `${value}%`);
        this.input.setAttribute('aria-valuetext', `${value}% cotton, ${100 - value}% slvr`);
      };
      this.input.disabled = false;
      this.input.addEventListener('input', this.update);
      this.update();
    }

    disconnectedCallback() {
      if (this.input) this.input.removeEventListener('input', this.update);
    }
  });

  // Survey rings fill when they scroll into view.
  customElements.define('slvr-x-rings', class extends HTMLElement {
    connectedCallback() {
      if (motion.matches || !('IntersectionObserver' in window)) return;
      const stats = this.querySelectorAll('.slvr-rr__stat');
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(({ target, isIntersecting }) => {
          if (!isIntersecting) return;
          target.classList.add('is-revealed');
          target.classList.remove('is-pending');
          this.observer.unobserve(target);
        });
      }, { threshold: 0.4 });
      stats.forEach((stat) => {
        stat.classList.add('is-pending');
        this.observer.observe(stat);
      });
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.querySelectorAll('.is-pending').forEach((stat) => stat.classList.remove('is-pending'));
    }
  });

  // Silver animation: plays only while visible, with a pause button.
  customElements.define('slvr-x-bond', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.slvr-mc__toggle');
      if (!this.button || !('IntersectionObserver' in window)) return;
      this.visible = false;
      this.paused = false;
      this.sync = () => {
        this.classList.toggle('is-playing', this.visible && !this.paused && !motion.matches && !document.hidden);
        this.button.hidden = motion.matches;
        this.button.textContent = this.paused ? 'Resume animation' : 'Pause animation';
      };
      this.toggle = () => {
        this.paused = !this.paused;
        this.sync();
      };
      this.button.addEventListener('click', this.toggle);
      document.addEventListener('visibilitychange', this.sync);
      motion.addEventListener('change', this.sync);
      this.observer = new IntersectionObserver((entries) => {
        this.visible = entries.some((entry) => entry.isIntersecting);
        this.sync();
      }, { threshold: 0.15 });
      this.observer.observe(this);
      this.sync();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.sync) {
        this.button.removeEventListener('click', this.toggle);
        document.removeEventListener('visibilitychange', this.sync);
        motion.removeEventListener('change', this.sync);
      }
      this.classList.remove('is-playing');
    }
  });
})();
